<div class="row p-1">
    <div class="col-12 pageTitle">
        <h2>
            Create Api Keys
        </h2>
    </div>
</div>

<form [formGroup]="keysForm" (ngSubmit)="save()">
    <div class="card">
        <div class="p-fluid formgrid grid">
            <div class="field col-12 md:col-4">
                <span class="p-float-label">
                    <input id="float-input1"
                           pInputText

                            formControlName="name"
                           type="text"
                           class="textboxBorder-1" />
                    <label for="float-input" >Key Name:</label>
                </span>
            </div>
            <div class="md:col-8"></div>
            <div class="md:col-4">
                    <button  type="submit" label="Save" pButton></button>
            </div>
        </div>
        </div>
</form>

<div class="card mt-5">
    <p-table [value]="(keys| async)">
        <ng-template pTemplate="header">
            <tr>


                <th>Name</th>
                <th>Key</th>
                <th>Actions</th>
            </tr>

        </ng-template>

        <ng-template pTemplate="body" let-key>
            <tr>
                <td>{{ key.name }}</td>
                <td>{{ key.apiKey }}</td>
                <td>


                    <button pButton
                            type="button"
                            icon="pi pi-trash"
                            class="p-button-link ml-3"
                            pTooltip="Delete"
                            (click)="delete(key['id'])"></button>
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <div class="w-12 bg-white">
                <div class="" style="text-align: center">
                    <img _ngcontent-ng-c683320295=""
                         class="profile-image"
                         style="border-radius: 50%; width: 10rem; padding-top: 1rem"
                         src="assets/imagesNew/table_error.png" />
                </div>
                <hr style="margin-bottom: 0.5rem" />
                <div class=""
                     style="text-align: center; font-size: larger; color: #1d428f">
                    <i>No Records found.</i>
                </div>
            </div>
        </ng-template>
    </p-table>
    </div>
